import styled from '@emotion/styled'
import { spacing } from '@instacart/ids-core'
import { Button, TextButton } from '@retailer-platform/shared-components'

export const SelectContainer = styled.div({
  marginTop: spacing.s16,
})

export const Row = styled.div({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
})

export const StoreGroupLink = styled.a(({ theme }) => ({
  marginLeft: 'auto',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: spacing.s8,
  color: theme.colors.brandPrimaryRegular,
  svg: {
    fill: theme.colors.brandPrimaryRegular,
  },
  textDecoration: 'none',
  ...theme.typography.bodyMedium1,
  ':hover': {
    color: theme.colors.brandSecondaryDark,
    svg: {
      fill: theme.colors.brandSecondaryDark,
    },
  },
}))

export const SelectedCountContainer = styled.div({
  marginTop: spacing.s16,
  display: 'flex',
  flexDirection: 'row',
  columnGap: spacing.s8,
})

export const StyledTextButton = styled(TextButton)(({ theme }) => ({
  ...theme.typography.bodyMedium1,
}))

export const StyledButton = styled(Button)({
  marginLeft: 0,
  marginRight: 0,
})

export const StoreGroupDisclaimer = styled.div({
  marginTop: spacing.s8,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: spacing.s4,
})
